// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`<Carousel> should match snapshot 1`] = `
.c0 {
  width: 320px;
}

.c1 {
  left: 0;
  -webkit-transition: left 375ms ease-in;
  transition: left 375ms ease-in;
}

@media (min-width:390px) {
  .c0 {
    width: 340px;
  }
}

@media (min-width:475px) {
  .c0 {
    width: 475px;
  }
}

@media (min-width:768px) {
  .c0 {
    width: 604px;
  }
}

@media (min-width:1024px) {
  .c0 {
    width: 726px;
  }
}

<div
  className="c0 flex flex-col mx-auto lg:mr-6"
>
  <div
    className="flex"
  >
    <div
      className="items-center flex hidden lg:flex"
    />
    <div
      className="c0 overflow-hidden"
    >
      <ul
        className="c0 c1 carousel__track relative flex ml-0"
        style={
          Object {
            "left": "0px",
            "width": "0px",
          }
        }
      />
    </div>
    <div
      className="items-center flex hidden lg:flex"
    />
  </div>
  <ul
    className="carousel-dot-nav flex justify-center mx-0 my-4 list-none"
  />
</div>
`;



//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/Activities/Carousel/__snapshots__/index.test.jsx.snap
// module id = 2638
// module chunks = 6